module.exports = __webpack_public_path__ + "img/image59.82440691.png";